export default {
  en: {
    signIn: 'Sign In',
    dontHaveAccount: "Don't have an account? Register for free",
    email: 'Email',
    emailError: 'Please fill in the email field',
    password: 'Password',
    passwordError: 'Please fill in the password field',
  },
  tr: {
    signIn: 'Giriş yap',
    dontHaveAccount: 'Hesabınız yok mu? Ücretsiz kayıt olun',
    email: 'E-posta',
    emailError: 'Lütfen e-posta alanını doldurun',
    password: 'Parola',
    passwordError: 'Lütfen şifre alanını doldurun',
  },
};
